function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var makeChipStyles = function makeChipStyles(_ref) {
  var primitives = _ref.primitives,
    tokens = _ref.tokens;
  return {
    MuiChip: {
      styleOverrides: {
        root: _objectSpread(_objectSpread(_objectSpread({}, tokens.typography["short-copy-small"]), {}, {
          fontWeight: primitives.fontWeights.stout,
          width: "fit-content",
          padding: "".concat(primitives.spacings["2"], " ").concat(primitives.spacings["3"]),
          backgroundColor: tokens.colors["detail-1-40"],
          color: tokens.colors["ink-on-background"]
        }, tokens.transitions["state-blur"]), {}, {
          "&:hover": _objectSpread({
            backgroundColor: tokens.colors["detail-1-40"]
          }, tokens.transitions["enter"]),
          "&.DhigChip--selected": _objectSpread({
            backgroundColor: tokens.colors["detail-2-opaque"],
            color: tokens.colors["ink-on-fill-primary"]
          }, tokens.transitions["state-activate"]),
          "&:has(svg:hover), &:has(svg:focus-visible)": _objectSpread({
            boxShadow: "none",
            backgroundColor: tokens.colors["detail-1-40"]
          }, tokens.transitions["state-activate"]),
          '& [class*="MuiChip-icon"]': {
            margin: "".concat(primitives.spacings[0], " ").concat(primitives.spacings["1"], " ").concat(primitives.spacings[0], " -").concat(primitives.spacings["1"]),
            fontSize: primitives.fontSizes["4"],
            color: tokens.colors["ink-on-background"],
            height: primitives.spacings["5"],
            width: primitives.spacings["5"]
          },
          '& [class*="MuiChip-deleteIcon"]': _objectSpread(_objectSpread({
            color: tokens.colors["ink-on-background"],
            fontSize: primitives.fontSizes["3"],
            outlineOffset: "1px",
            borderRadius: primitives.borderRadii.round,
            margin: "".concat(primitives.spacings[0], " -").concat(primitives.spacings["2"], " ").concat(primitives.spacings[0], " ").concat(primitives.spacings["1"]),
            display: "inline-block",
            position: "relative",
            zIndex: 1,
            padding: primitives.spacings["1"]
          }, tokens.transitions["state-blur"]), {}, {
            "&:hover, &:focus:not(:focus-visible):hover": _objectSpread({
              color: tokens.colors["ink-on-background"],
              backgroundColor: tokens.colors["activated-fill-subtle"]
            }, tokens.transitions["enter"]),
            "&:focus-visible": _objectSpread({
              boxShadow: tokens.effects["focus-ring-reverse"],
              outline: "none"
            }, tokens.transitions["state-activate"]),
            "&:focus:not(:focus-visible)": _objectSpread({
              boxShadow: "none",
              outline: "none"
            }, tokens.transitions["state-activate"]),
            "&:active, &:focus:not(:focus-visible):active": _objectSpread({
              backgroundColor: tokens.colors["activated-hover-fill-subtle"]
            }, tokens.transitions["state-activate"]),
            tabIndex: 0
          }),
          "&.Mui-disabled": {
            opacity: tokens.opacities["disabled"]
          }
        }),
        clickable: {
          "&:hover": {
            boxShadow: tokens.effects["halo-hover"],
            color: tokens.colors["ink-on-background"]
          },
          "&:focus-visible": _objectSpread({
            boxShadow: tokens.effects["focus-ring-reverse"],
            backgroundColor: tokens.colors["detail-1-40"]
          }, tokens.transitions["state-activate"]),
          "&:active": {
            boxShadow: tokens.effects["halo-pressed"]
          }
        },
        deletable: {
          "&:focus-visible": {
            boxShadow: tokens.effects["focus-ring-reverse"],
            backgroundColor: tokens.colors["detail-1-40"]
          }
        },
        colorError: {
          backgroundColor: tokens.colors.background,
          color: tokens.colors["ink-error"],
          border: "".concat(primitives.borderWidths.medium, " solid ").concat(tokens.colors["ink-error"]),
          "&.DhigChip--selected": {
            backgroundColor: tokens.colors["fill-error"],
            color: tokens.colors["ink-on-fill-alert"]
          }
        },
        label: {
          padding: primitives.spacings[0]
        }
      }
    }
  };
};